import { Component } from '@theme/component';

/**
 * A cart drawer upsell card. Keeps the hidden variant input, the displayed price and the
 * add button state in sync with the variant select.
 *
 * The select and the hidden input live inside the nested `product-form-component`, so their
 * `ref` attributes bind to that component, not to this one. They are queried directly instead.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} [price] - The current price node.
 * @property {HTMLElement} [comparePrice] - The compare at price node.
 *
 * @extends Component<Refs>
 */
class CartUpsellItem extends Component {
  /** @returns {HTMLSelectElement | null} */
  get variantSelect() {
    return this.querySelector('.cart-upsell__variant-select');
  }

  /** @returns {HTMLInputElement | null} */
  get variantIdInput() {
    return this.querySelector('input[name="id"]');
  }

  /** @returns {HTMLButtonElement | null} */
  get addButton() {
    return this.querySelector('.cart-upsell__button');
  }

  /**
   * Syncs the form to the variant selected in the dropdown.
   */
  handleVariantChange() {
    const option = this.variantSelect?.selectedOptions[0];
    const variantIdInput = this.variantIdInput;

    if (!option || !variantIdInput) return;

    const available = option.dataset.available === 'true';
    const { price, comparePrice } = this.refs;

    variantIdInput.value = option.value;
    variantIdInput.disabled = !available;

    if (price && option.dataset.price) price.textContent = option.dataset.price;

    if (comparePrice) {
      const compareAt = option.dataset.compareAtPrice ?? '';
      comparePrice.textContent = compareAt;
      comparePrice.hidden = compareAt === '';
    }

    const addButton = this.addButton;
    if (addButton) addButton.disabled = !available;
  }
}

if (!customElements.get('cart-upsell-item')) {
  customElements.define('cart-upsell-item', CartUpsellItem);
}
